/**
 * Row state and wire mapping for the summarization / content-generation
 * example pairs (Input Text + Wanted Output on the Examples step).
 */

let exampleRowSeq = 0;

export const newPairedExampleRow = () => ({
    id: `ex_${(exampleRowSeq += 1)}`,
    text: '',
    summary: '',
});

/** Wire ``SummarizationExample`` rows: both source text and summary/output must be present. */
export const toWireSummarizationExamples = (exampleRows) =>
    (exampleRows || []).flatMap((row) => {
        const text = (row.text || '').trim();
        const summary = (row.summary || '').trim();
        if (!text || !summary) return [];
        return [
            {
                kind: 'summarization',
                text,
                response: { kind: 'summarization', summary },
            },
        ];
    });

/**
 * Examples are optional, but a started pair must be completed: rows with only
 * one side filled are flagged (`{ text, summary }` marks the missing side).
 */
export const incompletePairedRowErrors = (exampleRows) => {
    const errors = {};
    (exampleRows || []).forEach((row) => {
        const text = (row.text || '').trim();
        const summary = (row.summary || '').trim();
        if ((text && !summary) || (!text && summary)) {
            errors[row.id] = { text: !text, summary: !summary };
        }
    });
    return errors;
};
